import React from "react";
import { Navbar, Container } from "react-bootstrap";
import { BsHouseFill } from "react-icons/bs";

const HeaderPage = () => {
  return (
    <Navbar
      expand="lg"
      className="main-navbar shadow forgot-navbar"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        margin: 0,
        padding: "0.5rem 1rem",
        zIndex: 9999,
        backgroundColor: "#fff",
      }}
    >
      <Container fluid>
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <div>
            <img
              src="images/swarna-logo.svg"
              className="img-fluid w-75"
              alt="Logo"
            />
          </div>
        </Navbar.Brand>

        <Navbar.Brand
          href="/SwarnandhraLogin"
          className="d-flex align-items-center"
        >
          <BsHouseFill
            className="mx-1 mb-1"
            style={{ fontSize: "30px" }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
      </Container>
    </Navbar>
  );
};

export default HeaderPage;